import { NumberInput } from '../../atoms'
import { BasicFormItem, BasicFormItemProps } from './BasicFormItem'

interface FormNumberProps extends BasicFormItemProps {
  min?: number
  max?: number
  disabled?: boolean
}

export const FormNumber = (props: Omit<FormNumberProps, 'component'>) => (
  <BasicFormItem component={NumberInput} {...props} />
)
